import styled from 'styled-components';

export const Container = styled.div<{ $open: boolean }>`
  height: ${({ $open }) => ($open ? '3.2rem' : '0')};

  transition: height 500ms;
  overflow: hidden;
`;

export const Content = styled.div`
  display: flex;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing(2)};

  padding: ${({ theme }) => `0 ${theme.spacing(2)}`};
  height: 3.2rem;

  border-radius: ${({ theme }) => theme.spacing(2)};
  background: ${({ theme }) => theme.palette.info.light};

  color: ${({ theme }) => theme.palette.info.dark};
`;

export const TagsContainer = styled.button`
  display: inline-flex;
  gap: ${({ theme }) => theme.spacing(1.5)};
  align-items: center;

  margin: 0;
  padding: 0;

  border: none;
  background: transparent;
  cursor: pointer;

  color: inherit;
`;

export const IconContainer = styled.span`
  font-size: 1.6rem;
  line-height: 62.5%;
`;

export const ClearButton = styled.button`
  padding: ${({ theme }) => theme.spacing(2.25)};
  margin: 0;

  cursor: pointer;
  background: transparent;
  border: none;

  font-size: 1.4rem;
  color: inherit;
  line-height: 62.5%;
`;
